import { Component, inject, input } from '@angular/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Store } from '@ngrx/store'
import { ActivityDataSource } from '@services/activity/notification.source'
import { getUser } from '@store'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { IBvNotification } from '@ziptility/modules'
import { NotificationComponent } from './notification.component'
import { toSignal } from '@angular/core/rxjs-interop'

@Component({
  selector: 'notification-list',
  template: `
    <div class="h-full" (click)="$event.stopPropagation()">
      <div
        id="list-wrapper"
        class="max-h-[500px] overflow-auto scrollbar-hide"
        style="-ms-overflow-style: none; scrollbar-width: none;"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="200"
        [scrollWindow]="false"
        (scrolled)="onScrollEnd()"
      >
        @if (dataSource(); as dataSource) {
          @if (!dataSource.notifications().length && !dataSource.loading) {
            <div>
              <div class="p-3">Nothing here yet.</div>
            </div>
          }
          @for (notification of dataSource.notifications(); track notification.id) {
            <notification [user]="user()" [notification]="notification" />
          }
          @if (dataSource.loading) {
            <div class="flex items-center justify-center h-full">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          }
        } @else {
          @if (notifications(); as notifications) {
            @if (!notifications?.length) {
              <div>
                <div class="no-results">Nothing here yet.</div>
              </div>
            }

            @for (notification of notifications; track notification.id) {
              <notification [user]="user()" [notification]="notification" />
            }
          }
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        height: 100%;
        overflow: auto;
      }
    `,
  ],
  imports: [InfiniteScrollDirective, NotificationComponent, MatProgressSpinnerModule],
})
export class NotificationListComponent {
  readonly store = inject(Store)
  readonly user = toSignal(this.store.select(getUser))
  readonly dataSource = input<ActivityDataSource | null>(null)
  readonly notifications = input<IBvNotification[] | null>(null)

  onScrollEnd() {
    this.dataSource()?.loadNextPage()
  }
}
